import useSEO from '../../hooks/useSEO';

export default function CookiePolicy() {
  // SEO dinámico
  useSEO({
    title: "Política de Cookies | SEOgenia",
    description: "Política de Cookies de SEOgenia. Información sobre el uso de cookies, tipos de cookies utilizadas y cómo desactivarlas en tu navegador.",
    keywords: "política cookies, cookies web, privacidad cookies, gestión cookies",
    canonical: "https://seogenia.es/politica-cookies",
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Política de Cookies",
      "description": "Política de Cookies de SEOgenia",
      "url": "https://seogenia.es/politica-cookies"
    }
  });

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">Política de Cookies</h1>
          <p className="text-lg sm:text-xl opacity-90">Última actualización: 15 de enero de 2025</p>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. ¿Qué son las Cookies?</h2>
            <p className="text-gray-700 leading-relaxed">
              Una cookie es un fichero que se descarga en su ordenador al acceder a determinadas páginas web. Las cookies permiten a una página web, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. ¿Qué Tipos de Cookies Utiliza esta Página Web?</h2>
            
            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Cookies Técnicas</h3>
              <p className="text-gray-700 leading-relaxed">
                Son aquellas que permiten al usuario la navegación a través de una página web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que en ella existan como, por ejemplo, controlar el tráfico y la comunicación de datos, identificar la sesión, acceder a partes de acceso restringido, recordar los elementos que integran un pedido, realizar el proceso de compra de un pedido, realizar la solicitud de inscripción o participación en un evento, utilizar elementos de seguridad durante la navegación, almacenar contenidos para la difusión de vídeos o sonido o compartir contenidos a través de redes sociales.
              </p>
            </div>

            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Cookies de Personalización</h3>
              <p className="text-gray-700 leading-relaxed">
                Son aquellas que permiten al usuario acceder al servicio con algunas características de carácter general predefinidas en función de una serie de criterios en el terminal del usuario como por ejemplo serian el idioma, el tipo de navegador a través del cual accede al servicio, la configuración regional desde donde accede al servicio, etc.
              </p>
            </div>

            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Cookies de Análisis</h3>
              <p className="text-gray-700 leading-relaxed">
                Son aquellas que bien tratadas por nosotros o por terceros, nos permiten cuantificar el número de usuarios y así realizar la medición y análisis estadístico de la utilización que hacen los usuarios del servicio ofertado. Para ello se analiza su navegación en nuestra página web con el fin de mejorar la oferta de productos o servicios que le ofrecemos.
              </p>
            </div>

            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Cookies Publicitarias</h3>
              <p className="text-gray-700 leading-relaxed">
                Son aquellas que, bien tratadas por nosotros o por terceros, nos permiten gestionar de la forma más eficaz posible la oferta de los espacios publicitarios que hay en la página web, adecuando el contenido del anuncio al contenido del servicio solicitado o al uso que realice de nuestra página web. Para ello podemos analizar sus hábitos de navegación en Internet y podemos mostrarle publicidad relacionada con su perfil de navegación.
              </p>
            </div>

            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Cookies de Publicidad Comportamental</h3>
              <p className="text-gray-700 leading-relaxed">
                Son aquellas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado. Estas cookies almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función del mismo.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Cookies de Terceros</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              En algunos casos, se instalan cookies de terceros que permiten gestionar y mejorar los servicios ofrecidos. Por ejemplo, servicios estadísticos de Google Analytics y servicios publicitarios de Google Adsense.
            </p>
            
            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-3">Google Analytics</h3>
              <p className="text-gray-700 leading-relaxed mb-2">
                Esta web utiliza Google Analytics, un servicio analítico de web prestado por Google, Inc., una compañía de Delaware cuya oficina principal está en 1600 Amphitheatre Parkway, Mountain View (California), CA 94043, Estados Unidos ("Google").
              </p>
              <p className="text-gray-700 leading-relaxed">
                Google Analytics utiliza "cookies", que son archivos de texto ubicados en tu ordenador, para ayudar al website a analizar el uso que hacen los usuarios del sitio web. La información que genera la cookie acerca de su uso del website (incluyendo tu dirección IP) será directamente transmitida y archivada por Google en los servidores de Estados Unidos.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Desactivar o Eliminar las Cookies</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              En cualquier momento podrá ejercer su derecho de desactivación o eliminación de cookies de este sitio web. Estas acciones se realizan de forma diferente en función del navegador que esté usando. A continuación, le facilitamos los enlaces de los principales navegadores:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Google Chrome:</strong> Configuración &gt; Mostrar opciones avanzadas &gt; Privacidad &gt; Configuración de contenido</li>
              <li><strong>Microsoft Edge:</strong> Configuración &gt; Ver configuración avanzada &gt; Privacidad y servicios &gt; Cookies</li>
              <li><strong>Mozilla Firefox:</strong> Herramientas &gt; Opciones &gt; Privacidad &gt; Historial &gt; Configuración Personalizada</li>
              <li><strong>Safari:</strong> Preferencias &gt; Seguridad</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              <strong>Nota importante:</strong> La desactivación de cookies puede provocar que algunos servicios o funcionalidades de la página web no estén disponibles.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Aceptación de la Política de Cookies</h2>
            <p className="text-gray-700 leading-relaxed">
              SEOgenia asume que usted acepta el uso de cookies si continúa navegando, considerando que se trata de una acción consciente y positiva de la que se infiere el consentimiento del Usuario. En relación a lo anterior se entiende que, de continuar navegando, estará prestando su consentimiento para el empleo de las referidas cookies y en las condiciones contenidas en la presente Política de Cookies.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Cambios en la Política de Cookies</h2>
            <p className="text-gray-700 leading-relaxed">
              SEOgenia puede modificar esta Política de Cookies en función de exigencias legislativas, reglamentarias, o con la finalidad de adaptar dicha política a las instrucciones dictadas por la Agencia Española de Protección de Datos, por ello se aconseja a los usuarios que la visiten periódicamente.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Datos de Contacto</h2>
            <p className="text-gray-700 leading-relaxed">
              Para cualquier consulta sobre esta Política de Cookies, puede contactar con nosotros:
            </p>
            <div className="bg-gray-50 rounded-xl p-6 mt-4">
              <p className="text-gray-700"><strong>Email:</strong> info@seogenia.es</p>
              <p className="text-gray-700"><strong>Teléfono:</strong> +34 659 357 423</p>
              <p className="text-gray-700"><strong>Dirección:</strong> Madrid, España</p>
            </div>
          </section>
        </div>

        {/* Back Button */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <a
            href="/"
            className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-500 font-semibold transition-colors"
          >
            <i className="ri-arrow-left-line"></i>
            Volver al inicio
          </a>
        </div>
      </div>
    </div>
  );
}
